import axios from '../axios'
// 消息发送表列表
export const getSysMessageSendPage = (data) => {
  return axios({
    url: '/api/sys/sys/message/send/getSysMessageSendPage',
    method: 'post',
    data
  })
}
// 保存消息发送表
export const saveSysMessageSend = (data) => {
  return axios({
    url: '/api/sys/sys/message/send/saveSysMessageSend',
    method: 'post',
    data
  })
}
// 删除消息发送表
export const deleteSysMessageSends = (data) => {
  return axios({
    url: '/api/sys/sys/message/send/deleteSysMessageSends',
    method: 'post',
    data
  })
}
// 消息接收表列表
export const getSysMessageReceivePage = (data) => {
  return axios({
    url: '/api/sys/sys/message/receive/getSysMessageReceivePage',
    method: 'post',
    data
  })
}
// 删除消息接收表
export const deleteSysMessageReceives = (data) => {
  return axios({
    url: '/api/sys/sys/message/receive/deleteSysMessageReceives',
    method: 'post',
    data
  })
}
// 消息垃圾箱列表
export const getSysMessageTrashPage = (data) => {
  return axios({
    url: '/api/sys/sys/message/trash/getSysMessageTrashPage',
    method: 'post',
    data
  })
}
// 删除消息垃圾箱
export const deleteSysMessageTrashs = (data) => {
  return axios({
    url: '/api/sys/sys/message/trash/deleteSysMessageTrashs',
    method: 'post',
    data
  })
}
// 更新已读状态
export const updateReadStatus = (data) => {
  return axios({
    url: '/api/sys/sys/message/receive/updateReadStatus',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/moudules/Mailbox.js